import React from 'react';

import { observer } from 'mobx-react';

import Record from 'ui/Record/Record';

import { MainHeader } from 'components/MainHeader/MainHeader';

import { useNavBarHeight } from 'utils/hooks/navbar';
import routes from 'core/routes';

import { useStore } from 'utils/hooks/store';

import MasterServiceAgreement from './MasterServiceAgreement';
import CompanyLogo from './CompanyLogo';
import OrganisationTimezone from './OrganisationTimezone';

const CompanySettings: React.FunctionComponent = (): React.ReactElement => {
  const navBarHeight = useNavBarHeight();

  const { session } = useStore();
  const showTimezone = !!session.user?.timezoneModelEnabled;

  return (
    <Record
      Header={
        <MainHeader
          title={session.user?.organisation.name || 'Organisation Name'}
          documentTitle="Company settings"
          breadcrumbs={[
            { label: 'Organisation', link: '' },
            { label: 'Company settings', link: routes.dashboard.settings.companySettings.toString() },
          ]}
        />
      }
      Content={() => (
        <>
          <CompanyLogo />
          {showTimezone && <OrganisationTimezone />}
          <MasterServiceAgreement />
        </>
      )}
      navBarHeight={navBarHeight}
    />
  );
};

export default observer(CompanySettings);
